<template>
  <div>
    <v-container>
      <v-row class="mb-4">
        <h2>Introductory Information</h2>
      </v-row>

      <v-simple-table class="mb-5">
        <thead>
          <tr v-for="field in fields1" :key="field.inputKey">
            <td style="width: 220px">
              {{ field.name }}
            </td>
            <td>
              <v-text-field v-model="inputs[field.inputKey]" />
            </td>
          </tr>
          <tr>
            <td style="width: 220px">Experiment was done:</td>
            <td>
              <v-select
                v-model="inputs.hasPartner"
                :items="partnerOptions"
                single
                chips
                class="mt-0"
              >
              </v-select>
            </td>
          </tr>
          <tr v-if="inputs.hasPartner === 'with partner(s)'">
            <td style="width: 220px">Name of Partner(s):</td>
            <td>
              <v-text-field v-model="inputs.partner" />
            </td>
          </tr>
          <tr v-for="field in fields2" :key="field.inputKey">
            <td style="width: 220px">
              {{ field.name }}
            </td>
            <td>
              <v-text-field v-model="inputs[field.inputKey]" />
            </td>
          </tr>
        </thead>
      </v-simple-table>
    </v-container>
  </div>
</template>

<script>
import DynamicQuestionMixin from '../../mixins/dynamic-question';

export default {
  name: 'QueensChem112Introduction',
  mixins: [DynamicQuestionMixin()],
  data() {
    return {
      inputs: {
        title: null,
        author: null,
        partner: null,
        demonstrator: null,
        date: null,
        hasPartner: null,
      },
      fields1: [
        {name: 'Experiment Title: ', inputKey: 'title'},
        {name: 'Name: ', inputKey: 'author'},
      ],
      fields2: [{name: 'Date Experiment Performed: ', inputKey: 'date'}],
      partnerOptions: ['individually', 'with partner(s)'],
    };
  },
};
</script>

<style scoped></style>
